import moment from 'moment-timezone';
import { DATE_FORMAT, TRANSACTION_TYPES } from 'src/utils/constants';

export const DEFAULT_TRANSACTION_TYPE = TRANSACTION_TYPES[0].id;

const TRANSACTION_TYPE_IDS = TRANSACTION_TYPES.map((type) => type.id);

const parseDate = (value) => {
  if (!value || !moment(value, DATE_FORMAT.unixDateTime, true).isValid()) return '';
  return value;
};

export const parseTransactionQuery = (search) => {
  const params = new URLSearchParams(typeof search === 'string' ? search : '');
  const requestedType = params.get('type');

  return {
    type: TRANSACTION_TYPE_IDS.includes(requestedType)
      ? requestedType
      : DEFAULT_TRANSACTION_TYPE,
    search: (params.get('search') || '').trim(),
    vehicle: (params.get('vehicle') || '').trim(),
    site: params.get('site') || 'all',
    tank: params.get('tank') || 'all',
    start: parseDate(params.get('start')),
    end: parseDate(params.get('end')),
    multiSearch: Array.from(params.entries()).reduce((result, [key, value]) => {
      if (key.startsWith('search_') && value.trim()) {
        return { ...result, [key.slice('search_'.length)]: value.trim() };
      }
      return result;
    }, {}),
  };
};

export const serializeTransactionQuery = (query = {}) => {
  const params = new URLSearchParams();
  const type = TRANSACTION_TYPE_IDS.includes(query.type)
    ? query.type
    : DEFAULT_TRANSACTION_TYPE;
  const search = (query.search || '').trim();
  const vehicle = (query.vehicle || '').trim();

  if (type !== DEFAULT_TRANSACTION_TYPE) params.set('type', type);
  if (search) params.set('search', search);
  if (vehicle) params.set('vehicle', vehicle);
  if (query.site && query.site !== 'all') params.set('site', String(query.site));
  if (query.tank && query.tank !== 'all') params.set('tank', String(query.tank));
  if (parseDate(query.start)) params.set('start', query.start);
  if (parseDate(query.end)) params.set('end', query.end);
  Object.entries(query.multiSearch || {}).forEach(([key, value]) => {
    if (value && String(value).trim()) params.set(`search_${key}`, String(value).trim());
  });

  return params.toString();
};
